/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { DBSchema, OpenDBCallbacks } from "idb";
import { DairyFARMDB, getDB } from "../store";
import { UserDescription } from "../../redux/users";

export const USERS_STORE = "users"

export interface UserStore extends DBSchema{
  [USERS_STORE]: {
    key: string;
    value: UserDescription;
  }
}

export const userStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction)
  {
    if (!db.objectStoreNames.contains(USERS_STORE)) {
      db.createObjectStore(  //unused store for now
        USERS_STORE, {
          keyPath: "id",
        });
    }
  }
}

export function loadUsers() {
  return getDB().then(db => db.getAll(USERS_STORE));
}
